import { atom } from "jotai";
import type { AdminOrderDetailResponse, OrderStatusCounts, PaginatedOrders } from "@models/order";

export const isProcessingOrderAtom = atom<boolean>(false);

// The me-scoped orders list (Account dashboard).
export const isFetchingMeOrdersAtom = atom<boolean>(false);

export const meOrdersFetchErrorAtom = atom<boolean>(false);

export const ordersListAtom = atom<PaginatedOrders>({
    pageNumber: 1,
    totalPages: 0,
    count: 0,
    hasPreviousPage: false,
    hasNextPage: false,
    items: [],
});

export const isFetchingOrdersListAtom = atom<boolean>(false);

// Per-status counts, kept independently so the admin top-bar Received badge
// can stay populated without depending on the Orders page being mounted (and
// without a header fetch clobbering the page's list data).
export const orderStatusCountsAtom = atom<OrderStatusCounts>({
    total: 0,
    received: 0,
    processing: 0,
    shipped: 0,
    delivered: 0,
    cancelled: 0,
});

// Admin order detail (GET /orders/{orderId:guid})
export const adminOrderDetailAtom = atom<AdminOrderDetailResponse | null>(null);

export const isFetchingAdminOrderAtom = atom<boolean>(false);

// Returned-payment fee orders whose last charge attempt answered "do not try
// again" — it may have collected the fee, or did (see
// Features/Admin/Orders/_helpers/returnedPaymentFeeError.ts), keyed by
// normalized order id. #469: most of those answers also leave the server's
// unconfirmed marker on the order, the durable block, but the page sees it
// only once its reload lands; charge_not_recorded may leave nothing on the
// order. So this block stands beside the marker. While an order is here its
// Charge Fee stays disabled and the dialog shows why.
//
// For the SESSION, in memory only: leaving and reopening the order keeps it,
// blocking another order keeps both, sign-out clears it, and a full page reload
// lifts it. A fee clear the API accepts on Unconfirmed Charges also lifts it
// (round 1b), unless it outlives a clear (charge_not_recorded: that charge is
// not the one the clear resolves).
export interface FeeChargeBlock {
    message: string;
    transactionId?: string;
    outlivesClear: boolean;
}

export const feeChargeBlocksAtom = atom<Record<string, FeeChargeBlock>>({});
